(function() {
  var KEY = 'mm_wishlist';
  var ACTIVE = 'active';
  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch(e) { return []; }
  }
  function saveList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    localStorage.setItem('shopify-wishlist', list.join(','));
  }
  function has(handle) { return getList().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) list.push(handle); else list.splice(idx, 1);
    saveList(list);
    return idx === -1;
  }
  function updateCount() {
    var c = getList().length;
    var els = document.querySelectorAll('[data-js-wishlist-count]');
    els.forEach(function(el) { el.textContent = c; });
    if (typeof mmUpdateWishCount === 'function') try { mmUpdateWishCount(); } catch(e) {}
  }
  function showToast(added) {
    var msg = added ? 'Aggiunto ai preferiti' : 'Rimosso dai preferiti';
    var d = document.createElement('div');
    d.style.cssText = 'position:fixed;bottom:90px;left:50%;transform:translateX(-50%);background:#333;color:#fff;padding:12px 24px;border-radius:8px;z-index:99999;font-size:14px;transition:opacity .3s;box-shadow:0 4px 12px rgba(0,0,0,.3);';
    d.textContent = msg;
    document.body.appendChild(d);
    setTimeout(function() { d.style.opacity = '0'; }, 2000);
    setTimeout(function() { d.remove(); }, 2500);
  }
  function setupButtons() {
    var btns = document.querySelectorAll('[button-wishlist]');
    btns.forEach(function(btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      if (has(handle)) btn.classList.add(ACTIVE);
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var added = toggle(handle);
        if (added) btn.classList.add(ACTIVE); else btn.classList.remove(ACTIVE);
        updateCount();
        showToast(added);
      });
    });
  }
  function fetchCard(handle) {
    return fetch('/products/' + handle + '?view=card')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.product-card') || doc.querySelector('.card') || doc.body.firstElementChild;
        return card ? card.outerHTML : '';
      });
  }
  function setupGrid() {
    var grid = document.querySelector('[grid-wishlist]');
    if (!grid || grid.classList.contains('loaded')) return;
    grid.classList.add('loaded');
    var list = getList();
    if (!list.length) return;
    Promise.all(list.map(fetchCard)).then(function(cards) {
      var html = cards.filter(function(c) { return c; }).join('');
      if (html) grid.innerHTML = html;
    });
  }
  function migrate() {
    var old = localStorage.getItem('shopify-wishlist');
    var cur = getList();
    if (old && !cur.length) {
      var handles = old.split(',').filter(function(h) { return h.trim(); });
      if (handles.length) saveList(handles);
    }
  }
  function init() { migrate(); setupButtons(); setupGrid(); updateCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();